import { render, staticRenderFns } from "./AddonFeeSchedule.vue?vue&type=template&id=1fdf3edc&scoped=true"
import script from "./AddonFeeSchedule.vue?vue&type=script&lang=js"
export * from "./AddonFeeSchedule.vue?vue&type=script&lang=js"
import style0 from "./AddonFeeSchedule.vue?vue&type=style&index=0&id=1fdf3edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf3edc",
  null
  
)

export default component.exports